export const GET_SUPPORT_CONTENT = 'getSupportContent'
export const GET_SUPPORT_INFOS = 'getSupportInfos'
